/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Polish (Poland)
export default {
  'ai-mate.chat-error-banner.description': 'Zapisywana jest historia czatu z maksymalnie 30 dni.',
  'ai-mate.chat-error-banner.title': 'Rozpocznij nowy czat',
  'ai-mate.chat-error.description': 'Spróbuj <btn>załadować czat ponownie</btn>.',
  'ai-mate.chat-error.rate-limited-description': 'Osiągnięto maksymalną liczbę żądań. Spróbuj ponownie później.',
  'ai-mate.chat-error.rate-limited-title': 'Zbyt wiele żądań',
  'ai-mate.chat-error.rovo-inactive-description':
    'Wygląda na to, że nie włączono Rovo w witrynie. <link>Konfigurowanie Rovo</link>',
  'ai-mate.chat-error.rovo-inactive-title': 'Rovo jest nieaktywne',
  'ai-mate.chat-error.title': 'Nie wiemy, co poszło nie tak',
  'conversation-assistant-button.label': 'Czat',
  'conversation-assistant-button.rovo-chat-label': 'Czat Rovo',
  'highlight-actions.rovo-chat-custom-prompt.placeholder': 'Zapytaj o to AI',
  'highlight-actions.rovo-chat-explain-option.text': 'Wyjaśnij',
  'highlight-actions.rovo-chat-explain-prompt': 'Wyjaśnij: {selectedText}',
  'highlight-actions.rovo-chat-more-options.tooltip': 'Zalecenia dotyczące czatu',
  'highlight-actions.rovo-chat-open-chat.tooltip': 'Otwórz czat',
  'highlight-actions.rovo-chat-summarize-option.text': 'Podsumuj',
  'highlight-actions.rovo-chat-summarize-prompt': 'Podsumuj: {selectedText}',
  'highlight-actions.rovo-chat.button-text': 'Czat',
  'horizontal-scroll-container.scroll-left': 'Przewiń w lewo',
  'horizontal-scroll-container.scroll-right': 'Przewiń w prawo',
};
